import { render, staticRenderFns } from "./AppCoreHeaderCommunication.vue?vue&type=template&id=281a34ac"
import script from "./AppCoreHeaderCommunication.vue?vue&type=script&lang=js"
export * from "./AppCoreHeaderCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports